import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useCurrentUser } from '../../contexts/CurrentUserContext'
import CurrentUserStore from '../../contexts/CurrentUserStore'

const SuperAdminRoute = ({ children }) => {
  const { currentUser } = useCurrentUser()
  const location = useLocation()

  if (currentUser.id === CurrentUserStore.id) {
    return null
  }

  const roles = currentUser.roles
  const isAllowed = roles.some(role => role === 'Super Administrator')
  return isAllowed ? (
    children
  ) : (
    <Navigate to="/ui/disputes" state={{ from: location }} />
  )
}

export default SuperAdminRoute
